module.exports = "/templates/taskcalendar.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/taskcalendar.html
// module id = 469
// module chunks = 0